export const projectColorPalette = {
  SWATCH_0: "#A5CFFD",
  SWATCH_1: "#FFD798",
  SWATCH_2: "#ACF686",
  SWATCH_3: "#FF8F72",
  SWATCH_4: "#BC91D9",
  SWATCH_5: "#FF99CA",
  SWATCH_6: "#6BBD73",
  SWATCH_7: "#51ABC9",
  SWATCH_8: "#A8B9C5",
  SWATCH_9: "#F3EAEA",
} as const

export const projectColorSwatches = Object.keys(projectColorPalette) as ProjectColorSwatch[]

export type ProjectColorSwatch = keyof typeof projectColorPalette